module.exports = __webpack_public_path__ + "static/img/e39d5aaecf8745128ccdd99f8070775e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_03.png
// module id = 2Wyw
// module chunks = 1